import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

import { ZIndex } from "../../shared/constants";
import { PreviewAspectRatio, type Scale } from "../models";
import { calculateDimensions } from "../utils/calculateDimensions";

export const PreviewViewer = styled.div<{ scale?: Scale; aspectRatio?: PreviewAspectRatio }>`
    position: relative;

    overflow: hidden;

    width: ${({ scale, aspectRatio = PreviewAspectRatio.nineSixteen }) =>
        `${calculateDimensions(aspectRatio, scale).width}px`};
    height: ${({ scale, aspectRatio = PreviewAspectRatio.nineSixteen }) =>
        `${calculateDimensions(aspectRatio, scale).height}px`};

    background-color: ${Colors.Gray.V50};
    border-radius: ${Spacing["1XS"]}px;

    video {
        border-radius: 6px;
    }
`;

export const ImagePreview = styled.img`
    width: 100%;
    border-radius: 6px;
`;

export const reviewedNotification = css`
    position: absolute;
    z-index: ${ZIndex.LensPreviewNotification};
    top: 8px;
    left: 8px;
`;

export const grayBackground = css`
    background-color: ${Colors.Gray.V50};
`;
